import { getNextPlanForLimits, getUserTier } from '../../shared/plans';

export default (user, eventDetail = {}) => {

  const tests = [

    // Logged out users
    (user, eventDetail) => !user.isZuulUser && ['fresh', 'bronze_trial_plan'],

    // Expired users with a valid card
    (user, eventDetail) => user.isExpiredUser && user.hasValidCard && ['expired_valid_card', 'bronze_monthly'],

    // Expired users with an invalid card
    (user, eventDetail) => user.isExpiredUser && !user.hasValidCard && ['expired_invalid_card', 'bronze_monthly'],

    // Upselling users who are hitting limits or curious about upgrading
    (user, eventDetail) => {
      const { limit, requested, browsing } = eventDetail;

      if (limit && limit.match(/ranking/)) {
        const statePrefix = browsing ? 'curious_about' : 'out_of';

        let userState = `${statePrefix}_${limit}`;

        // Get the next plan up with the number of lists they requested.
        let priceId = getNextPlanForLimits(user, limit, requested);

        // If they're gold, there's nowhere they can go - set a userState that will show them the 'contact support' modal
        if (!priceId && getUserTier(user) === 'gold') {
          userState = 'curious_about_even_more_ranking_lists';
        };

        // Handle an edge case: if user has downgraded from gold but still has the gold limit number of lists, priceId will be null because 'requested' would be one more than the max of any plan.
        // So we need to re-request a priceId with their current number of lists, which should be 'requested' minus one.
        if (!priceId && ['bronze', 'silver', 'hold'].includes(getUserTier(user))) {
          priceId = getNextPlanForLimits(user, limit, (requested - 1));
        }

        return [userState, priceId];
      }

    }

  ];

  for (const test of tests) {
    const [ userState, priceId ] = test(user, eventDetail) || [];
    if (userState) return { userState, priceId };
  }

  throw `Could not determine the user's state!`;

};